import { render, staticRenderFns } from "./LogoText.vue?vue&type=template&id=b6fd76f2&"
import script from "./LogoText.vue?vue&type=script&lang=js&"
export * from "./LogoText.vue?vue&type=script&lang=js&"
import style0 from "./LogoText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports